import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "19",
  fill: "none",
  viewBox: "0 0 18 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "9",
      cy: "5.699",
      r: "1",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M9 8.9v4.6m-8-4a8 8 0 1 1 16 0 8 8 0 0 1-16 0Z"
    }, null, -1)
  ])))
}
export default { render: render }